<template>
  <div class="useles-buttons-container">
    <div class="useles-button-item-container">
      <div class="useles-button-item" @click="$emit('on-create-new-operation', 'income')">
        <button class="useles-button-icon-container">
          <arrow-down-circle-icon class="useles-button-icon green" />
        </button>
        <p class="useles-button-name">{{$t('analytics.incomeTitle')}}</p>
      </div>
      <div class="useles-button-item" @click="$emit('on-create-new-operation', 'cost')">
        <button class="useles-button-icon-container">
          <arrow-up-circle-icon class="useles-button-icon red" />
        </button>
        <p class="useles-button-name">{{$t('analytics.costTiitle')}}</p>
      </div>
      <!-- <div class="useles-button-item">
          <button class="useles-button-icon-container">
            <refresh-cw-icon class="useles-button-icon blue"/>
          </button>
          <p class="useles-button-name">{{$t('analytics.transferTitle')}}</p>
        </div> -->
      <div class="useles-button-item" @click="$emit('on-create-new-operation', 'create')">
        <button class="useles-button-icon-container">
          <file-plus-icon class="useles-button-icon brown" />
        </button>
        <p class="useles-button-name">{{ $t('homePage.createButton') }}</p>
      </div>
    </div>
  </div>
</template>

<script>

import {  
  ArrowUpCircleIcon, 
  ArrowDownCircleIcon,
  // RefreshCwIcon,
  FilePlusIcon
} from 'vue-feather-icons';

export default {
    name: "Buttons-top-container",
    components: {
        ArrowUpCircleIcon,
        ArrowDownCircleIcon,
        // RefreshCwIcon,
        FilePlusIcon
    },
    props: {
        isOpenMenuSideBar: {
            type: Boolean,
            require: true
        }
    },
    data() {
        return {
        }
    },
    async mounted() {

    },

    methods: {

    },
    computed: {

    },
    watch: {

    }
}
</script>

<style scoped>
.useles-buttons-container {
  margin: 0px 15px 10px 15px;
}

.useles-button-item-container {
  display: flex;
  text-align: center;
  justify-content: space-between;
}

.useles-button-item {
  cursor: pointer;
}

.useles-button-icon-container {
  display: flex;
  background-color: #FFF; 
  width: 65px;
  height: 65px;
  transform: translateY(2px);
  border: none;
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  transition: all .25s ease;
  cursor: pointer;
  box-shadow: 10px 10px 10px #d1d9e6, -10px -10px 10px #f9f9f9;
}

.useles-button-icon-container:active {
  box-shadow: none;
}

.useles-button-icon {
    width: 28px;
    height: 28px;
    margin: auto;
}

.useles-button-icon.green {
    color: #8CC152;
}
.useles-button-icon.red {
    color: #d84558;
}
.useles-button-icon.blue {
    color: #4A89DC;
}
.useles-button-icon.brown {
    color: #AA8E69;
}

.useles-button-name {
  font-size: 13px;
  opacity: 0.8;
  color: #1b1b1b;
  font-family: "Source Sans 3", sans-serif;
  font-weight: 600;
  padding-top: 8px;
  line-height: 20px;
  letter-spacing: 0px;
}
</style>